import request from '@/utils/http'
import { PFX, SRM_FILE_PRE } from '../../constant/constant.js'

// 分页查询
export const queryBidPlanPage = data => {
    return request({
        url: `${PFX}/bid/queryBidPlanPage`,
        method: 'post',
        data,
    })
}

// 导出
export const exportBidPlan = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/exportBidPlan`,
        method: 'post',
        data,
    })
}

// 确认标段导出模板下载
export const lineTplDownload = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/lineTplDownload`,
        method: 'post',
        data,
    })
}

// 确认标段、编辑标段、下发招采原因、计划审批、发布公告、重新招采
export const planOperate = data => {
    return request({
        url: `${PFX}/bid/planOperate`,
        method: 'post',
        data,
    })
}

// 保存原因、统一原因保存
export const saveLineNoBidReason = data => {
    return request({
        url: `${PFX}/bid/saveLineNoBidReason`,
        method: 'post',
        data,
    })
}

// 统一原因保存显示控制
export const validPlanNoBidReasonNoneNull = data => {
    return request({
        url: `${PFX}/bid/validPlanNoBidReasonNoneNull`,
        method: 'get',
        params: data,
    })
}

// 招采计划导入下载模板校验
export const tplDownloadValid = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/analysisTenderCost/tplDownloadValid`,
        method: 'post',
        data,
    })
}

// 招采计划导入下载模板接口
export const tplDownload = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/analysisTenderCost/tplDownload`,
        method: 'post',
        data,
    })
}

// 线路明细导入下载模板接口
export const lineDetailTplDownload = params => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/lineSyncImport/tplDownload`,
        method: 'get',
        params,
    })
}

// 线路明细导入接口
export const lineSyncImport = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/lineSyncImport`,
        method: 'post',
        data,
    })
}

// 招采计划-商机分页查询
export const opportunityQuery = data => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunity/query`,
        method: 'post',
        data,
    })
}

// 招采计划-合同分页查询
export const contractQuery = data => {
    return request({
        url: `${PFX}/bid/bidPlan/contract/query`,
        method: 'post',
        data,
    })
}

// 招采计划-合同新增
export const contractAdd = data => {
    return request({
        url: `${PFX}/bid/bidPlan/contract/add`,
        method: 'post',
        data,
    })
}

// 招采计划-合同编辑
export const contractModify = data => {
    return request({
        url: `${PFX}/bid/bidPlan/contract/modify`,
        method: 'post',
        data,
    })
}

// 招采计划-合同新增-根据法务合同号查询合同信息
export const queryByContract = data => {
    return request({
        url: `${PFX}/contract/contractInfo/bidPlan/query`,
        method: 'post',
        data,
    })
}

// 招采计划-商机、合同删除
export const bidPlanDelete = data => {
    return request({
        url: `${PFX}/bid/bidPlan/delete`,
        method: 'post',
        data,
    })
}

// 招采计划-商机新增
export const opportunityAdd = data => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunity/add`,
        method: 'post',
        data,
    })
}

// 招采计划-商机新增-根据商机编码查询商机信息
export const queryByOpportunity = data => {
    return request({
        url: `${PFX}/analysis/analysisOpportunityInfo/bidPlan/query`,
        method: 'post',
        data,
    })
}

// 招采计划-商机编辑
export const opportunityModify = data => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunity/modify`,
        method: 'post',
        data,
    })
}

// 招采计划-商机、合同取创建时间第一条数据
export const opportunityContractFirstData = params => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunityContract/firstData`,
        method: 'get',
        params,
    })
}

// 招采计划-商机、合同发布公告
export const opportunityContractNoticeApply = data => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunityContract/noticeApply`,
        method: 'post',
        data,
    })
}

// 招采计划-商机、合同计划审批
export const opportunityContractPlanAudit = data => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunityContract/planAudit`,
        method: 'post',
        data,
    })
}

// 招采计划-招标编码查询弹框
export const planQuery = data => {
    return request({
        url: `${PFX}/bid/notice/plan/query`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-筛选结果分页查询
export const resultQuery = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/result/query`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-项目信息查询
export const projectInfoQuery = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/projectInfo/query`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-邀请招标
export const bidSearchInfoInvite = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/invite`,
        method: 'post',
        data,
    })
}

// 招采寻源-智能寻源详情分页查询
export const queryDetailPage = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/queryDetailPage`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-筛选请求发起
export const resultSearchSubmit = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/resultSearchSubmit`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-合同导出
export const contractExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/bidPlan/contract/export`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-商机导出
export const opportunityExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidPlan/bidPlan/opportunity/export`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-筛选导出
export const resultExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidSearchInfo/result/export`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-详情导出
export const detailExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidSearchInfo/detail/export`,
        method: 'post',
        data,
    })
}

// 招采计划-招采寻源-智能寻源详情-批次供应商分页查询
export const bidSearchSupplierQueryPage = data => {
    return request({
        url: `${PFX}/bid/bidSearchSupplier/queryPage`,
        method: 'post',
        data,
    })
}

// 招采计划-商机、合同取创建时间第一条数据
export const firstDataByFdId = params => {
    return request({
        url: `${PFX}/bid/bidPlan/opportunityContract/firstDataByFdId`,
        method: 'get',
        params,
    })
}

// 招采计划-商机、合同编辑保存
export const bidPlanModify = data => {
    return request({
        url: `${PFX}/bid/bidPlan/detail/modify`,
        method: 'post',
        data,
    })
}

// 智能寻源-添加供应商邀标
export const inviteSupplierList = data => {
    return request({
        url: `${PFX}/bid/bidSearchInfo/inviteSupplierList`,
        method: 'post',
        data,
    })
}

// 智能寻源-邀请内容查询
export const bidHead = data => {
    return request({
        url: `${PFX}/bid/bidSearchSendInfo/bidHead/${data}`,
        method: 'get',
    })
}

// 智能寻源-邀请内容保存
export const modifyByBidNo = data => {
    return request({
        url: `${PFX}/bid/bidSearchSendInfo/modifyByBidNo`,
        method: 'post',
        data,
    })
}

// 商机/合同-查询招采计划详情接口
export const queryDetailInfoById = data => {
    return request({
        url: `${PFX}/bid/bidPlan/queryDetailInfoById`,
        method: 'post',
        data,
    })
}

// 商机/合同-招采计划变更详情接口
export const changeInfoByFdId = data => {
    return request({
        url: `${PFX}/bid/bidPlan/changeInfoByFdId`,
        method: 'get',
        params: data,
    })
}

// 商机/合同-操作记录分页接口
export const operationLogPage = data => {
    return request({
        url: `${PFX}/bid/bidPlan/operationLog/queryPage`,
        method: 'post',
        data,
    })
}

// 商机/合同-提交审批
export const changeSubmitIflow = data => {
    return request({
        url: `${PFX}/bid/bidPlan/changeSubmitIflow`,
        method: 'post',
        data,
    })
}
